<template>
  <div class="leftmenu">
    <div style="float:right;margin-top:-25px;margin-right:5px">
      <el-tooltip effect="dark" content="点击进入菜单引导~" placement="top-end">
        <i class="el-icon-question" @click="startGuide" style="font-size:20px;cursor:pointer;"></i>
      </el-tooltip>
    </div>

    <ul>
      <template
        v-if="userInfo.audit_status == 1 && (userInfo.practice_license && userInfo.practice_license != '')"
      >
        <li
          v-for="(item,index) in menuList"
          :key="'menu'+index"
          @click="goto(item.name)"
          :class="{active:menuName == item.name ||(index ==0 && !menuName)}"
          :name="item.name"
        >
          <i :class="item.icon"></i>
          &nbsp;&nbsp;{{item.title}}
        </li>
      </template>
      <template v-else>
        <li
          v-for="(item,index) in menuList"
          :key="'menu'+index"
          :class="{active:menuName == item.name ||(index ==0 && !menuName)}"
          :name="item.name"
          style="cursor: no-drop;"
        >
          <i :class="item.icon"></i>
          &nbsp;&nbsp;{{item.title}}
        </li>
      </template>
    </ul>
    <v-tour name="myTour" :steps="menuList" :options="myOptions" :callbacks="myCallbacks"></v-tour>
  </div>
</template>

<script>
export default {
  data() {
    return {
      myCallbacks: {
        onStop: this.stopBack, //完成或跳过回调
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "跳过引导",
          buttonPrevious: "上一步",
          buttonNext: "下一步",
          buttonStop: "完成引导",
        },
      },

      userInfo: {}, //当前登录用户信息

      menuName: null, //用于选择侧边
      menuList: [], //权限菜单数据
      liData: [
        {
          name: "comProjectLaunch",
          title: "发起省区项目",
          icon: "el-icon-tickets",

          target: '[name="comProjectLaunch"]', // 引导相关参数
          content:
            "省区事务代表发起项目的列表，能进行发起、编辑项目和查看基金会的审核意见~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "comProjectAuditList",
          title: "公益项目审核",
          icon: "el-icon-tickets",

          target: '[name="comProjectAuditList"]', // 引导相关参数
          content:
            "省区事务代表审核地方执行机构信的列表，能进行地方执行机构的立项、结项信审核~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "comProEnd",
          title: "省区合作项目结项",
          icon: "el-icon-tickets",

          target: '[name="comProEnd"]', // 引导相关参数
          content:
            "省区事务代表提交结项报告列表，能进行下属机构结项报告的查看和报告汇总的提交",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "hospitalBuildList",
          title: "公益项目申请",
          type: 1,
          icon: "el-icon-tickets",

          target: '[name="hospitalBuildList"]', // 引导相关参数
          content:
            "申请基金会公益项目的列表，能进行项目的申请、申请编辑、提交盖章协议和查看基金会的审核意见~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "hospitalComProjectList",
          title: "公益项目信息",
          type: 1,
          icon: "el-icon-tickets",

          target: '[name="hospitalComProjectList"]', // 引导相关参数
          content:
            "已经申请的公益项目信息列表，能进行项目信息的查看、提交媒体报道、提交报告、和提交结项~",
          // params: {
          //   placement: "top"
          // }
        },

        {
          name: "comProjectApply",
          title: "公益救助花名册",
          type: 1,
          icon: "el-icon-tickets",

          target: '[name="comProjectApply"]', // 引导相关参数
          content:
            "公益救助人员列表，能进行公益救助人员信息的导入、修改、删除和查看基金会审核意见~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "comProDonation",
          title: "公益捐款信息",
          type: 1,
          icon: "el-icon-tickets",

          target: '[name="comProDonation"]', // 引导相关参数
          content: "公益项目捐款列表，能进行对基金会进行捐款操作~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "hospitalPaymentList",
          title: "公益结算信息",
          type: 1,
          icon: "el-icon-tickets",

          target: '[name="hospitalPaymentList"]', // 引导相关参数
          content:
            "公益项目结算计划列表，能进行所有申请公益项目的金额结算操作~",
          // params: {
          //   placement: "top"
          // }
        },

        // {
        //   name: "hospitalComProjectBudget",
        //   title: "公益回款管理",
        //   type: 1,
        //   icon: "el-icon-tickets",

        //   target: '[name="hospitalComProjectBudget"]', // 引导相关参数
        //   content:
        //     "公益项目回款信息的列表，能进行查看各个项目的基金会的拨款信息和提交回款信息~"
        // },

        {
          name: "cfProjectList",
          title: "众筹项目信息",
          type: 2,
          icon: "el-icon-tickets",

          target: '[name="cfProjectList"]', // 引导相关参数
          content:
            "众筹项目信息的列表，能进行众筹项目的申请、提交报告和媒体报道的操作~",
          // params: {
          //   placement: "top"
          // }
        },

        {
          name: "cfProApplyList",
          title: "众筹救助申请",
          type: 2,
          icon: "el-icon-tickets",

          target: '[name="cfProApplyList"]', // 引导相关参数
          content:
            "众筹项目的救助信息列表，能进行众筹救助的申请、补充信息、提交回访记录和媒体报道及查看基金会审核意见的操作~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "cfProAppropriation",
          title: "众筹拨款申请",
          type: 2,
          icon: "el-icon-tickets",

          target: '[name="cfProAppropriation"]', // 引导相关参数
          content:
            "所有众筹项目拨款的列表，能进行众筹手术和非手术项目拨款的申请、编辑和查看基金会审核意见的操作~",
          // params: {
          //   placement: "top"
          // }
        },

        {
          name: "hospitalUserManagementList",
          title: "人员管理",
          icon: "el-icon-tickets",

          target: '[name="hospitalUserManagementList"]', // 引导相关参数
          content: "机构人员管理列表，能进行人员的信息的添加、修改、删除~",
          // params: {
          //   placement: "top"
          // }
        },
        {
          name: "unitInfoSet",
          title: "机构信息",
          icon: "el-icon-tickets",

          target: '[name="unitInfoSet"]', // 引导相关参数
          content: "机构注册信息，能进行机构信息的查看和修改操作~",
          // params: {
          //   placement: "top"
          // }
        },
      ],
    };
  },
  methods: {
    stopBack() {
      //把跳过状态记录到数据库
      this.$db.post(this.$db.config.changeGuideStatus, {}).then((res) => {
        // if (res && res.code == 200) {
        sessionStorage.setItem("skip_status", 1);
        // }
      });
    },
    startGuide() {
      this.$tours["myTour"].start();
    },
    goto(name) {
      this.$router.push(name);
      sessionStorage.setItem("unitChannelName", name);
    },

    //获取菜单权限列表
    getMenuList() {
      if (this.userInfo.type == 4) {
        //超级管理员
        if (this.userInfo.if_agent == 1) {
          //省区代表
          this.menuList = this.liData;
        } else {
          this.liData.splice(0, 3);
          this.menuList = this.liData;
        }
      } else if (this.userInfo.type == 1) {
        //公益负责人
        let list = this.liData.filter((item) => {
          return item.type && item.type == 1;
        });
        this.menuList = list;
      } else if (this.userInfo.type == 2) {
        //众筹负责人
        let list = this.liData.filter((item) => {
          return item.type && item.type == 2;
        });
        this.menuList = list;
      } else if (this.userInfo.type == 3) {
        //公益众筹负责人
        this.liData.splice(0, 2);
        this.liData.splice(-2);
        this.menuList = this.liData;
      }
    },
  },
  created() {
    if (!sessionStorage.getItem("unitAuth")) {
      this.$router.push({ name: "unitLogin" });
    } else {
      let info = JSON.parse(sessionStorage.getItem("unitAuth"));
      this.userInfo = info;
      this.getMenuList();
      if (!(info.practice_license && info.practice_license != "")) {
        this.menuName = "unitInfoSet";
        this.$router.push({ name: "unitInfoSet" });
        return false;
      }
      let name;
      name = sessionStorage.getItem("unitChannelName");
      if (name) {
        this.menuName = name;
      } else {
        this.menuName = this.$parent.$route.name;
      }
    }
  },

  mounted() {
    if (this.userInfo.step == 1) {
      let status = sessionStorage.getItem("skip_status");
      if (status && status == 1) {
      } else {
        //需要引导页面
        this.startGuide();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.leftmenu {
  background-color: #fff;
  width: 100%;
  text-align: left;
  border-top: 2px solid #b60205;
  padding-top: 30px;
  overflow: hidden;
  margin-bottom: 288px;
  > ul {
    padding: 0 20px;
    width: 85%;
    > li {
      list-style: none;
      font-size: 14px;
      font-weight: bold;
      color: #666;
      margin-bottom: 40px;
      cursor: pointer;
    }
    > li.active {
      color: #b60205;
    }
  }
}
.leftmenu /deep/ .v-step {
  z-index: 999999999;
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/Hospital/public/menu.vue